































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { RepasseProjecao } from '@/types/interfaces/RepasseProjecao'
import { formatValorBRL } from '@/utils/formatacaoNumerica'
import { formatRepasseDate, getCustoAntecipacao, getRepasseFinal, sortRepassesByDataDesc } from './repasseProjecao'

type LinhaRepasse = {
  data: string
  dataFormatada: string
  desconto: string
  custo: string
  isAtual: boolean
}

@Component({ name: 'AntecipacaoDescontoRepasse' })
export default class AntecipacaoDescontoRepasse extends Vue {
  @Prop({ type: Array, default: () => [] }) repasses: RepasseProjecao[]
  @Prop({ type: Number, required: true }) valorSolicitado: number
  @Prop({ type: Boolean, default: false }) carregando: boolean

  expandido: boolean = false

  get repasseFinal(): RepasseProjecao | null {
    return getRepasseFinal(this.repasses)
  }

  get dataRepasseFinal(): string {
    return this.repasseFinal ? formatRepasseDate(this.repasseFinal.data) : ''
  }

  get descontoRepasseFinal(): string {
    return this.repasseFinal ? formatValorBRL(this.repasseFinal.desconto) : ''
  }

  get toggleLabel(): string {
    return this.expandido ? 'Ocultar próximos repasses' : 'Ver próximos repasses'
  }

  get linhas(): LinhaRepasse[] {
    const repassesDecrescentes = sortRepassesByDataDesc(this.repasses)
    const indiceAtual = repassesDecrescentes.length - 1

    return repassesDecrescentes.map((repasse, indice) => ({
      data: repasse.data,
      dataFormatada: formatRepasseDate(repasse.data),
      desconto: formatValorBRL(repasse.desconto),
      custo: formatValorBRL(getCustoAntecipacao(repasse, this.valorSolicitado)),
      isAtual: indice === indiceAtual,
    }))
  }

  alternarExpandido() {
    this.expandido = !this.expandido
  }
}
